import React from "react";

import Portfolio from "./components/portfolio";

function App() {
  return (
    <div
      className="appBackground"
      style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/bg1.png)` }}
    >
      <div className="appBody">
        <Portfolio />
      </div>
      <footer className="globalFooter" aria-label="Site footer">
        <span className="globalFooterText">© Leo Yamamoto Saenger 2026</span>
        <span className="globalFooterSep"> • </span>
        <a
          className="globalFooterLink"
          href="https://johnrakestraw.com/post/the-value-of-civilization/"
          target="_blank"
          rel="noopener noreferrer"
        >
          background quote
        </a>
      </footer>
    </div>
  );
}

export default App;
